class CustomerDataQuestion extends Question {
  constructor(handle, diagnostic, answersData) {
    super(handle, diagnostic, answersData);
  }
  answerQuestion(event) {
    let nextQuestion = event.target.dataset.nextQuestion;

    // Populate customer data in diagnostic data
    if (event.target.tagName == "FORM") {
      let formData = new FormData(event.target);
      formData.forEach((value, key) => {
        this.diagnostic.data[key] = value;

        //Custom path for special questions
        if (event.target.dataset.type == "nom-genre" && key == "gender" && value == "male") {
          this.diagnostic.data.answers.push({
            "handle": "q3-chamboulement-hormonal",
            "answer": "q3-aucun"
          });
          nextQuestion = "q4-regime-alimentaire";
        }
      });
      const consentEmailCheckbox = event.target.querySelector('#consent-email');
      if (consentEmailCheckbox) {
        this.diagnostic.data['optin'] = consentEmailCheckbox.checked;
      }
    }
    if (nextQuestion) {
      this.diagnostic._updateDataHistory();
      this.diagnostic.instanciateQuestion(nextQuestion);
    } else {
      this.diagnostic.submitDiagnostic();
    }
  }
  instanciateQuestion(handle) {
    super.instanciateQuestion(handle);

    // //Remove the name field in the second question if i do the diagnostic for someone else
    // if(handle == "q1-nom-genre" &&this.diagnostic.data["this_is_for"] == "someone_else"){
    //     let nameField = document.querySelector('input[name="name"]');
    //     if(nameField){
    //         nameField.remove();
    //     }
    // }
  }
  registerEvents() {
    document.querySelector('.customerDataForm').addEventListener('submit', event => {
      event.preventDefault();
      this.answerQuestion(event);
    });
    document.querySelector('.skip-step')?.addEventListener('click', event => {
      this.answerQuestion(event);
    });
    document.querySelector('.back-button')?.addEventListener('click', () => {
      this.previousQuestion();
    });
  }
  populateQuestionAnswers(answersData) {
    const formElem = document.querySelector('.customerDataForm');
    if (formElem) {
      const inputs = formElem.querySelectorAll('input');

      // For each input, check if there is a completed value in data and change the input value
      inputs.forEach(input => {
        let inputType = input.getAttribute('type');
        let inputName = input.getAttribute('name');
        switch (inputType) {
          case 'text':
          case 'email':
            let value = answersData[inputName];
            value ? input.value = value : null;
            break;
          case 'radio':
            input.value == answersData[inputName] ? input.checked = true : null;
            break;
          default:
            break;
        }
      });
    }
  }
}